<template>
    <intersect @enter="handleEnter">
        <div class="map" :class="classes" v-cloak>
            <transition>
                <div class="map-error" v-if="error">
                    <h4>We’re having some issues.</h4>
                    <p>{{ errorMessage }}</p>
                </div>
            </transition>
            <!--<button type="button" v-if="moved" @click="resetMap">Reset Map</button>-->
            <slot></slot>
            <div class="map-layers" v-if="layers.length > 1">
                <div class="map-layer-selector">
                    <label class="map-layer" v-for="layer in layers">
                        <input type="radio" v-model="activeLayer" :value="layer">
                        <span class="map-layer-name">{{ layer.name }}</span>
                    </label>
                </div>
                <div class="map-layer-description container">
                    <slot name="layer-description" v-bind="layerDescriptionScope"></slot>
                </div>
            </div>
            <google-map ref="map" class="map-canvas" v-if="visible">
                <map-marker :position="marker.getPosition()" :title="marker.title" :options="marker.getOptions()" v-for="marker in visibleMarkers" :key="marker.getId()" @click="selectMarker(marker)"></map-marker>

                <template v-for="polygon in polygons">
                    <map-polygon v-for="shape, index in polygon.getShapes()" :path="shape" :options="polygon.getOptions()" :key="polygon.getShapeId(index)"></map-polygon>
                </template>

                <info-window :position="infoWindowPosition" :opened="infoWindowOpen" :options="infowWindowOptions" v-if="infoWindowOpen" @closeclick="handleInfoWindowCloseClick">
                    <div class="infowindow">
                        <slot name="infowindow" v-bind="infoWindowScope"></slot>
                    </div>
                </info-window>
            </google-map>
        </div>
    </intersect>
</template>
<script>
    import NetworkingMixin from "../../mixins/networking";
    import MapUtilitiesMixin from "../../mixins/map-utilities";
    import Cluster from './Cluster';
    import MapPolygon from './MapPolygon';
    import Intersect from 'vue-intersect';

    export default {
        mixins: [NetworkingMixin, MapUtilitiesMixin],
        components: {
            cluster: Cluster,
            mapPolygon: MapPolygon,
            intersect: Intersect,
        },
        data() {
            return {
                visible: false,
                initialDataLoaded: false,
                activeMarker: null,
                activeLayer: null,
                layers: [],
                mapOptions: {},
            }
        },
        computed: {
            classes() {
                return {
                    'is-loading': !this.bootstrapped || this.querying,
                }
            },
            errorMessage() {
                if (this.error) {
                    return 'Sorry, we’re having a problem loading the ' + this.activeLayer.name + ' layer. Please check back later, or give us a call and we’ll be happy to help.';
                }

                return null;
            },
            infowWindowOptions() {
                let options = {};

                let icon = this.activeMarker.getIcon();
                if (icon) {
                    options.pixelOffset = {
                        width: 0,
                        height: icon.scaledSize.height * -0.75,
                    }
                }

                return options;
            },
            infoWindowPosition() {
                return this.activeMarker ? this.activeMarker.getPosition() : null;
            },
            infoWindowOpen() {
                return this.activeMarker !== null;
            },
            infoWindowScope() {
                return {
                    marker: this.activeMarker,
                }
            },
            layerDescriptionScope() {
                return {
                    activeLayer: this.activeLayer,
                }
            },
        },
        methods: {
            selectMarker(marker) {
                this.activeMarker = marker;
            },
            handleInfoWindowCloseClick() {
                this.activeMarker = null;
            },
            handleEnter() {
                this.visible = true;
            },
            findLayerById(id) {
                if (id) {
                    let layers = this.layers.filter((layer) => {
                        return layer.id == id;
                    });

                    return layers[0];
                }

                return null;
            }
        },
        mounted() {
            this.layers = this.$children.filter((child) => child.$options.name === 'map-layer');
        },
        watch: {
            visible(visible) {
                if (visible) {
                    if (this.layers.length > 0) {
                        let hashLayer = this.findLayerById(window.originalHash)
                        this.activeLayer = hashLayer ? hashLayer : this.layers[0];
                    }
                }
            },
            data(data) {
                this.fitToMarkers();

                if (!this.initialDataLoaded) {
                    this.activeLayers = this.layers.map(layer => layer.id);
                    this.initialDataLoaded = true;
                }
            },
            activeLayer(layer) {
                this.$nextTick().then(() => {
                    this.activeMarker = null;
                    this.api = layer.api;
                    this.$refs.map.setOptions(layer.options);
                });
            }
        },
    }
</script>
